import { MessageDescriptor } from 'react-intl';

import * as UserSegmentation from '../../../../../models/user-segmentation';

import messages from './messages';

export const getTeamSpecificExamples = (teamType: string): MessageDescriptor[] => {
	switch (teamType) {
		case UserSegmentation.USER_SEGMENTATION_TEAM_TYPE_SOFTWARE:
			return [
				messages.softwareExample1,
				messages.softwareExample2,
				messages.softwareExample3,
				messages.softwareExample4,
				messages.softwareExample5,
			];
		case UserSegmentation.USER_SEGMENTATION_TEAM_TYPE_PRODUCT_MANAGEMENT:
			return [
				messages.pmExample1,
				messages.pmExample2,
				messages.pmExample3,
				messages.pmExample4,
				messages.pmExample5,
			];
		case UserSegmentation.USER_SEGMENTATION_TEAM_TYPE_MARKETING:
			return [
				messages.marketingExample1,
				messages.marketingExample2,
				messages.marketingExample3,
				messages.marketingExample4,
				messages.marketingExample5,
			];
		case UserSegmentation.USER_SEGMENTATION_TEAM_TYPE_DESIGN:
			return [
				messages.designExample1,
				messages.designExample2,
				messages.designExample3,
				messages.designExample4,
				messages.designExample5,
			];
		case UserSegmentation.USER_SEGMENTATION_TEAM_TYPE_PROJECT_MANAGEMENT:
			return [
				messages.projectManagementExample1,
				messages.projectManagementExample2,
				messages.projectManagementExample3,
				messages.projectManagementExample4,
				messages.projectManagementExample5,
			];
		case UserSegmentation.USER_SEGMENTATION_TEAM_TYPE_OPERATIONS:
			return [
				messages.operationsExample1,
				messages.operationsExample2,
				messages.operationsExample3,
				messages.operationsExample4,
				messages.operationsExample5,
			];
		case UserSegmentation.USER_SEGMENTATION_TEAM_TYPE_IT_SUPPORT:
			return [
				messages.itSupportExample1,
				messages.itSupportExample2,
				messages.itSupportExample3,
				messages.itSupportExample4,
				messages.itSupportExample5,
			];
		case UserSegmentation.USER_SEGMENTATION_TEAM_TYPE_HR:
			return [
				messages.hrExample1,
				messages.hrExample2,
				messages.hrExample3,
				messages.hrExample4,
				messages.hrExample5,
			];
		case UserSegmentation.USER_SEGMENTATION_TEAM_TYPE_CUSTOMER_SERVICE:
			return [
				messages.customerServiceExample1,
				messages.customerServiceExample2,
				messages.customerServiceExample3,
				messages.customerServiceExample4,
				messages.customerServiceExample5,
			];
		case UserSegmentation.USER_SEGMENTATION_TEAM_TYPE_LEGAL:
			return [
				messages.legalExample1,
				messages.legalExample2,
				messages.legalExample3,
				messages.legalExample4,
				messages.legalExample5,
			];
		case UserSegmentation.USER_SEGMENTATION_TEAM_TYPE_FINANCE:
			return [
				messages.financeExample1,
				messages.financeExample2,
				messages.financeExample3,
				messages.financeExample4,
				messages.financeExample5,
			];
		case UserSegmentation.USER_SEGMENTATION_TEAM_TYPE_SALES:
			return [
				messages.salesExample1,
				messages.salesExample2,
				messages.salesExample3,
				messages.salesExample4,
				messages.salesExample5,
			];
		case UserSegmentation.USER_SEGMENTATION_TEAM_TYPE_DATA_SCIENCE:
			return [
				messages.dataScienceExample1,
				messages.dataScienceExample2,
				messages.dataScienceExample3,
				messages.dataScienceExample4,
				messages.dataScienceExample5,
			];
		case UserSegmentation.USER_SEGMENTATION_TEAM_TYPE_OTHER_PERSONAL:
			return [
				messages.otherExample1,
				messages.otherExample2,
				messages.otherExample3,
				messages.otherExample4,
				messages.otherExample5,
			];
		default:
			return [
				messages.otherExample1,
				messages.otherExample2,
				messages.otherExample3,
				messages.otherExample4,
				messages.otherExample5,
			];
	}
};

export const getDefaultProjectName = (
	teamType: string,
	defaultProjectName: string,
	formatMessage: (descriptor: MessageDescriptor) => string,
): string => {
	const teamExamples = getTeamSpecificExamples(teamType);
	const firstExample = teamExamples[0];
	if (firstExample) {
		return formatMessage(firstExample);
	}
	return defaultProjectName;
};
